// Automatically add width and height attributes to images that don't have them
// This improves CLS (Cumulative Layout Shift) scores and page performance

document.addEventListener('DOMContentLoaded', function() {
    // Skip if we're in WordPress admin area
    if (document.body.classList.contains('wp-admin')) {
        return;
    }
    
    function addImageDimensions() {
        // Select all images
        const images = document.querySelectorAll('img');
        
        images.forEach(img => {
            const src = img.getAttribute('src') || img.getAttribute('data-src') || '';
            const isSvg = src.toLowerCase().endsWith('.svg');
            
            // Handle SVG images differently
            if (isSvg) {
                // Try to extract dimensions from inline style
                const style = img.getAttribute('style');
                if (style) {
                    const widthMatch = style.match(/width:\s*(\d+)px/);
                    const heightMatch = style.match(/height:\s*(\d+)px/);
                    
                    if (widthMatch && heightMatch) {
                        const width = widthMatch[1];
                        const height = heightMatch[1];
                        
                        // Update or set the attributes with the correct dimensions
                        img.setAttribute('width', width);
                        img.setAttribute('height', height);
                    } else {
                        // Remove incorrect dimensions from SVGs without inline styles
                        img.removeAttribute('width');
                        img.removeAttribute('height');
                    }
                }
                return; // Don't process SVGs further
            }
            
            // For non-SVG images, skip if already has both width and height
            if (img.hasAttribute('width') && img.hasAttribute('height')) {
                return;
            }
            
            // Function to set dimensions for regular images
            function setDimensions() {
                // Get natural dimensions
                const width = img.naturalWidth;
                const height = img.naturalHeight;
                
                // Only set if we have valid dimensions
                if (width && height) {
                    // Only set if not already set
                    if (!img.hasAttribute('width')) {
                        img.setAttribute('width', width);
                    }
                    if (!img.hasAttribute('height')) {
                        img.setAttribute('height', height);
                    }
                }
            }
            
            // If image is already loaded
            if (img.complete && img.naturalWidth !== 0) {
                setDimensions();
            } else {
                // Wait for image to load
                img.addEventListener('load', setDimensions);
                
                // Handle error case
                img.addEventListener('error', function() {
                    console.warn('Failed to load image:', img.src);
                });
            }
        });
    }
    
    // Run on DOM ready
    addImageDimensions();
    
    // Also run after a short delay to catch any dynamically loaded images
    setTimeout(addImageDimensions, 500);
    
    // Optional: Re-run when new content is added (useful for AJAX-loaded content)
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                addImageDimensions();
            }
        });
    });
    
    // Observe the body for added nodes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});

